import React, { useState, useEffect } from 'react';
import Pagination from 'react-js-pagination';
import { useSelector } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { toast } from 'react-toastify';
import { useMutation, useQuery } from 'react-query';
import { Image } from 'react-bootstrap';
import { AsyncPaginate } from 'react-select-async-paginate';
import { ASSETGROUP_API, BaseGatewayImage, ROLE_API } from '@app/utils/apiUrl.js';
import { DeleteSingle, Get, Post } from '@app/utils/httpProvider';
import {
    createUrlWithParam,
    formatDateTimeCrawler,
    formatDateTimeMoment,
    formatDateTimeWithoutHour,
    formatDateTimeWithoutHourMoment,
    getInfomationAccountFromToken,
    isValidUrl
} from '../../utils/helper';
import { URI_INTERNAL } from '../../utils/pathLocations';
import {
    objectShowNumber,
    messageToast,
    objectDeviceStatus,
    deviceStatus,
    styleSelectDefault,
    role,
    objectTrangThaiDeNghi,
    trangThaiDeNghiValue
} from '../../utils/define';
import { ConfirmModal } from '../../modules/modal/ConfirmModal';
import { BrowserView, MobileView } from 'react-device-detect';
import Select from 'react-select';
import SelectTree from '@app/components/select-tree/SelectTree';
import { NIL as NIL_UUID } from 'uuid';

const AssetGroup = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    // let accountRoleAdmin = false;
    // const inforAccount = getInfomationAccountFromToken();

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role;
    //     accountRoleAdmin =
    //         userRole.includes(role.Admin) || userRole.includes(role.Editor);
    // }

    const deleteFunc = useMutation((value) =>
        DeleteSingle(ASSETGROUP_API.DELETE_ITEM, value, null)
    );

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (
        paramUrl.get('page') != null &&
        parseInt(paramUrl.get('page'), 10) !== page
    ) {
        const pageResult = parseInt(paramUrl.get('page'), 10);
        setPage(pageResult);
    }
    if (
        paramUrl.get('size') != null &&
        parseInt(paramUrl.get('size'), 10) !== pageSize
    ) {
        const sizeResult = parseInt(paramUrl.get('size'), 10);
        setPageSize(sizeResult);
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    // const [isSortedNameAlphabet, setIsSortedNameAlphabet] = useState(false);

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['assetGroupData', valueSearch, page, pageSize],
        () => {
            let model = {
                Keyword: valueSearch ? valueSearch : '',
                PageIndex: page,
                PageSize: pageSize
            };

            replaceHistory(page, pageSize, valueSearch ? valueSearch : '');

            return Get(ASSETGROUP_API.GET_PAGING, null, model);
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page]);

    const replaceHistory = async (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.ASSETGROUP_PATH, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    React.useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(e.target.value);
        replaceHistory(page, e.target.value, search);
    };

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (idWantDelete !== '') {
            deleteFunc.mutate(idWantDelete, {
                onSuccess: (res) => {
                    if (res.status === 201 || res.status === 200) {
                        refetch();
                        toast.success(messageToast.messageToastDeleteSuccess);
                        if (
                            data != null &&
                            data.data.length === 1 &&
                            page !== 1
                        ) {
                            history.push(
                                createUrlWithParam(
                                    URI_INTERNAL.ASSETGROUP_PATH,
                                    {
                                        page: page - 1,
                                        size: pageSize,
                                        search: search
                                    }
                                )
                            );
                        }
                    } else {
                        toast.error(messageToast.messageToastDeleteError);
                    }
                },
                onError: (res) => {
                    toast.error(messageToast.messageToastTryCatch);
                }
            });

            replaceHistory(page, pageSize, search);
            setOpenConfirmDeleteModal(false);
        }
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    // chọn nhiều dòng + chọn roles
    const [selectedIds, setSelectedIds] = useState(new Set()); // id của các dòng đã tick
    const [selectedRoles, setSelectedRoles] = useState([]);    // các role chọn bởi AsyncPaginate

    const listRole = useQuery(['getAllRolesFromAuthServer'], () =>
        Get(ROLE_API.GET_PAGING, null, {
            PageIndex: 1,
            PageSize: 10000
        })
    );

    const lstRoleFlat =
        listRole?.data?.data?.length > 0
            ? listRole.data.data.map((x) => ({
                id: x.id,
                name: x.name,
                // normalize root parentId to NIL_UUID
                parentId:
                    x.parentId && x.parentId !== NIL_UUID ? x.parentId : NIL_UUID,
            }))
            : [];

    // === Chọn tất cả trên trang / chọn từng dòng ===
    const currentPageIds = data?.data?.map((x) => x.id) ?? [];
    const isAllPageChecked =
        currentPageIds.length > 0 && currentPageIds.every((id) => selectedIds.has(id));

    const toggleCheckAllPage = () => {
        setSelectedIds((prev) => {
            const next = new Set(prev);
            if (isAllPageChecked) {
                // Bỏ chọn tất cả
                currentPageIds.forEach((id) => next.delete(id));
            } else {
                // Chọn tất cả
                currentPageIds.forEach((id) => next.add(id));
            }
            return next;
        });
    };

    const toggleRow = (id) => {
        setSelectedIds((prev) => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    };

    // === Bulk assign roles ===
    const bulkAssignMutation = useMutation((payload) =>
        Post(ASSETGROUP_API.BULK_ASSIGN_ROLES, null, payload)
    );

    const onApplyRolesForSelected = () => {
        if (selectedIds.size === 0) {
            toast.warn('Vui lòng chọn ít nhất một dòng.');
            return;
        }
        if (!selectedRoles || selectedRoles.length === 0) {
            toast.warn('Vui lòng chọn ít nhất một quyền.');
            return;
        }

        // Chuẩn hoá về dạng AllowedRole[] theo đúng DTO của BE
        const allowedRolesForSend = selectedRoles.map(r => ({
            id: r.id,         // Guid
            name: r.name ?? r.label ?? r.value // tuỳ nguồn dữ liệu, ưu tiên name
        }));

        // Lấy các ApiRoleMapping đã tick và gắn LstAllowedRoles cho từng item
        const itemsForSend = (data?.data ?? [])
            .filter(x => selectedIds.has(x.id))
            .map(x => ({
                id: x.id,                  // Guid? nếu BE không cần Id khi bulk-add mới, có thể bỏ
                controller: x.controller,  // theo ApiRoleMappingRequest
                action: x.action,          // theo ApiRoleMappingRequest
                lstAllowedRoles: allowedRolesForSend
            }));

        // Gọi API: endpoint nhận List<ApiRoleMappingRequest>
        bulkAssignMutation.mutate(itemsForSend, {
            onSuccess: () => {
                toast.success('Áp dụng quyền thành công.');
                setSelectedIds(new Set());
                // (tuỳ chọn) Optimistic update UI cột "Các quyền cho phép dùng"
                // setData(prev => ({
                //   ...prev,
                //   data: prev.data.map(row =>
                //     selectedIds.has(row.id)
                //       ? { ...row, lstAllowedRoles: allowedRolesForSend }
                //       : row
                //   )
                // }));
                refetch();
            },
            onError: () => {
                toast.error('Áp dụng quyền thất bại, vui lòng thử lại.');
            },
        });
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header bg-white py-3">
                            <h5 className="card-title fw-bold text-primary mb-0">
                                <i className="fas fa-layer-group mr-2" />
                                Danh sách nhóm tài sản
                            </h5>
                        </div>
                        <div className="card-body">
                            <div className="row mb-3 align-items-center">
                                {/* Action Buttons - Top on Mobile */}
                                <div className="col-12 col-md-auto order-1 order-md-2 ml-md-auto mb-3 mb-md-0">
                                    <div className="d-flex justify-content-center justify-content-md-end">
                                        <NavLink
                                            className="nav-link-reject nav-link p-0"
                                            to={URI_INTERNAL.ASSETGROUP_CREATE_PATH}
                                        >
                                            <button
                                                type="button"
                                                className="btn btn-info btn-action-equal"
                                            >
                                                Thêm mới
                                            </button>
                                        </NavLink>
                                    </div>
                                </div>

                                {/* Filter & Page Size - Bottom on Mobile */}
                                <div className="col-12 col-md-auto order-2 order-md-1 d-flex flex-wrap align-items-center justify-content-between justify-content-md-start">
                                    <div className="d-flex align-items-center mb-2 mb-md-0">
                                        <label className="mr-2 mb-0 text-nowrap">Hiển thị:</label>
                                        <select
                                            className="form-control form-control-sm"
                                            value={pageSize}
                                            onChange={(e) => onChangeShowNumber(e)}
                                            style={{marginRight: '20px'}}
                                        >
                                            {objectShowNumber.map((item, key) => (
                                                <option key={Number(key)} value={item.value}>
                                                    {item.text}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {isLoading ? (
                                <div>Đang tải...</div>
                            ) : isError ? (
                                <div>Có lỗi xảy ra: ${error.message}</div>
                            ) : (
                                <div
                                    id="example2_wrapper"
                                    className="dataTables_wrapper dt-bootstrap4"
                                // style={{
                                //     marginTop: accountRoleAdmin
                                //         ? '0px'
                                //         : '20px'
                                // }}
                                >
                                    <div className="row">
                                        <div
                                            className="col-sm-12"
                                            style={{ overflow: 'auto' }}
                                        >
                                            <Table striped bordered hover className="mb-0 mobile-card-view">
                                                <thead>
                                                    <tr role="row">
                                                        <th className="sorting">
                                                            STT
                                                        </th>
                                                        <th className="sorting">
                                                            Mã nhóm
                                                        </th>
                                                        <th className="sorting">
                                                            Tên nhóm
                                                        </th>
                                                        <th className="sorting">
                                                            Chức năng
                                                        </th>
                                                    </tr>
                                                </thead>
                                                {data != null &&
                                                    data.data != null &&
                                                    data.data != null &&
                                                    data.data !== undefined &&
                                                    data.data.length > 0 ? (
                                                    <tbody>
                                                        {data.data.map(
                                                            (item, index) => (
                                                                <tr
                                                                    key={Number(
                                                                        index
                                                                    )}
                                                                    className="odd"
                                                                >
                                                                    <td className="text-center align-middle font-weight-light" data-label="STT">
                                                                        {index + 1 + (page - 1) * pageSize}
                                                                    </td>
                                                                    <td className="align-middle fw-bold text-dark" data-label="MÃ NHÓM">
                                                                        {item.assetGroupCode}
                                                                    </td>
                                                                    <td className="align-middle" data-label="TÊN NHÓM">
                                                                        {item.assetGroupName}
                                                                    </td>
                                                                    <td className="text-center align-middle">
                                                                        <div className="d-flex justify-content-center">
                                                                            <NavLink
                                                                                to={createUrlWithParam(
                                                                                    URI_INTERNAL.ASSETGROUP_EDIT_PATH,
                                                                                    { id: item.id }
                                                                                )}
                                                                                className="btn btn-outline-primary btn-sm mr-2"
                                                                                title="Sửa"
                                                                            >
                                                                                <i className="fas fa-pen" />
                                                                            </NavLink>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline-danger btn-sm"
                                                                                onClick={() => deleteAction(item.id, item.assetGroupName)}
                                                                                title="Xóa"
                                                                            >
                                                                                <i className="fas fa-trash" />
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                        <tr className="txt-center">
                                                            <td colSpan="12">
                                                                Không có dữ liệu
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                )}

                                            </Table>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-sm-12 d-flex justify-content-center">
                                            <Pagination
                                                itemClass="page-item"
                                                linkClass="page-link"
                                                innerClass="pagination pagination-sm mb-0"
                                                activePage={page}
                                                itemsCountPerPage={Number(
                                                    pageSize
                                                )}
                                                totalItemsCount={
                                                    data != null
                                                        ? data.totalRecords
                                                        : 0
                                                }
                                                pageRangeDisplayed={5}
                                                onChange={(number) =>
                                                    changePage(number)
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                            <ConfirmModal
                                isOpen={openConfirmDeleteModal}
                                confirmType="delete"
                                handleAccept={() => acceptDelete()}
                                handleCancel={() => cancelDelete()}
                                content={confirmDelMessage}
                            />
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    );
};

export default AssetGroup;
